import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { push } from 'react-router-redux';
import HomeCategories from '../components/HomeCategories';
import HomeBannerSlider from '../components/homeBanner/HomeBannerSlider';
import HomeConnect from '../components/home/HomeConnect';
import DirectoryOrgs from '../components/DirectoryLandingPage/DirectoryOrgs';
import FeaturedOrgs from '../components/featuredOrgsHomePage/FeaturedOrgs';
import {
  loadBannerFeaturedOrgs,
  loadOrgsByType,
  loadFeaturedHomeOrganizations,
  openSignupFormRequest
} from '../actions';

import DocumentMeta from 'react-document-meta';

class DirectoryLandingPage extends Component {
  constructor(props) {
    super(props);
  }

  componentWillMount() {
    this.props.loadFeaturedHomeOrganizations();
    this.props.loadBannerFeaturedOrgs();
    this.props.loadOrgsByType({
      is_dir_lp: true
    });
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  handleSignUpClick = (e) => {
    window.scrollTo(0, 0);
    e.preventDefault();
    this.props.openSignupFormRequest();
  }

  render() {

    if (!this.props.baseState.isLoaded) {
      return <span />;
    }
    if (!this.props.orgsByType.isLoaded) {
      return <span />;
    }

    const meta = {
      title: 'WorldWideWomen | The first-ever global resource center for women',
      description: "Check out WorldWideWomen, a global resource center for women and girls with listings on education, health, entertainment, financial planning, work, women’s rights.",
      canonical: 'https://worldwidewomen.co/',
      meta: {
        property: {
          'og:image': 'https://worldwidewomen.co/images/www_fb_logo.jpg'
        }
      },
      auto: {
        ograph: true,
      },
    }

    return (
      <div>
        <DocumentMeta {...meta} />

        <div className="homeBannerFeaturedOrgs">
          <HomeBannerSlider
            homeBannerOrgs = {this.props.homeBannerFeaturedOrganizations}
            browser = {this.props.browser}
            auth={this.props.auth}
            openSignupFormRequest={this.props.openSignupFormRequest}
          />
        </div>

        <div className="content-wrapper directoryLP-outerWrapper">

          <div className="directoryLP-introWrapper">
            <div className="directoryLP-intro">
              <h1>Global Resource Directory</h1>
              <p>Welcome to the global resource directory for women and girls. Our team researches and carefully vets valuable organizations, programs and services exclusively for women and girls and assembles them into this easy-to-use directory.</p>
              <p>Search across categories from women's and girls' rights to workplace rights and support for female entrepreneurs and more and then filter by your location to find valuable resources.</p>
            </div>
            <div className="directoryLP-instructions">
              <p></p>
              <ul>Here are a few tips on how to explore resources available to you in your area:
                <li>First, <a href="#" onClick={this.handleSignUpClick.bind(this)}>sign up</a> as a WorldWideWomen member (which is free!)</li>
                <li>Next, click on the category of resources you are searching for. For example, if you are looking for a resource supporting education for girls, select Girls' Rights and if you are seeking resources for women-owned businesses, select Entrepreneurs.</li>
                <li>Then, narrow your search by choosing one of the subcategories in the sidebar menu</li>
                <li>Finally, filter by your location by choosing one or more of the locations in the menu on your left</li>
                <li>If your region is not listed, type a region or a city into the search box and all kinds of resources in that location will appear.</li>
              </ul>
            </div>
          </div>


          <div className="home-categories-wrapper">
            <HomeCategories />
          </div>


          <HomeConnect
            user = {this.props.auth}
            openSignupFormRequest={this.props.openSignupFormRequest}
          />


          <div className="buyFromWomen-orgListingsWrapper">
            <DirectoryOrgs
              orgsByType = {this.props.orgsByType}
              user = {this.props.auth.user}
              loadOrgsByType = {this.props.loadOrgsByType}
            />
          </div>



        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return state;
};

export default connect(
  mapStateToProps,
  {
    push,
    loadBannerFeaturedOrgs,
    loadOrgsByType,
    loadFeaturedHomeOrganizations,
    openSignupFormRequest
  })(DirectoryLandingPage);



// WEBPACK FOOTER //
// ./src/containers/DirectoryLandingPage.jsx